import { GoInfo } from 'react-icons/go';

export interface MappedGeneItem {
  id: string;
  name: string;
  filterParam?: string;
}

interface MappedGeneInfoButtonProps {
  gene: MappedGeneItem;
  onOpenPanel: (item: { id: string; symbol: string; entityView: string }) => void;
}

export function MappedGeneInfoButton({ gene, onOpenPanel }: MappedGeneInfoButtonProps) {
  return (
    <button
      type="button"
      className="p-0 ms-1 tab-links"
      onClick={() => onOpenPanel({ id: gene.id, symbol: gene.name, entityView: 'GENES' })}
      title="Show gene information"
    >
      <GoInfo className="w-5 h-4 stroke-1 text-blue m-1" />
    </button>
  );
}
